module.exports = __webpack_public_path__ + "static/media/hair (28).3a2aaa6f.jpg";